<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YzAEgS/images/cover.jpg?1685327667005" alt="This image is the cover for the book The Battle for Bonhoeffer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Battle for Bonhoeffer
      </h1>
      <p class="bookDescription body article font2">
        <p>The figure of Dietrich Bonhoeffer (1906–1945) has become a clay puppet in modern American politics. Secular, radical, liberal, and evangelical interpreters variously shape and mold the martyr’s legacy to suit their own pet agendas.</p><p>Stephen Haynes offers an incisive and clarifying perspective. A recognized Bonhoeffer expert, Haynes examines “populist” readings of Bonhoeffer, including the acclaimed biography by Eric Metaxas, <i>Bonhoeffer: Pastor, Martyr, Prophet, Spy</i>. In his analysis Haynes treats, among other things, the November 2016 election of Donald Trump and the “Bonhoeffer moment” announced by evangelicals in response to the US Supreme Court’s 2015 decision to legalize same-sex marriage.</p><i>The Battle for Bonhoeffer </i>includes an open letter from Haynes pointedly addressing Christians who still support Trump. Bonhoeffer’s legacy matters. Haynes redeems the life and the man.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen R. Haynes
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Stephen R. Haynes</B>&#160;is professor of religious studies at Rhodes College, adjunct professor of recovery ministry at Fuller Theological Seminary, and theologian-in-residence at Idlewild Presbyterian Church in Memphis, Tennessee. A contributor to&#160;<I>The Christian Century</I>&#160;and&#160;<I>HuffPost</I>, he is the author of several books, including&#160;<I>The Battle for Bonhoeffer: Debating Discipleship in the Age of Trump</I>&#160;and&#160;<I>The Last Segregated Hour: The Memphis Kneel-Ins and the Campaign for Southern Church Desegregation.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?254211c0